import { Mapping } from "three";

const Settings = {
  // Sound
  globalVolume: 1,

  countdown: 120,

  evilSoundControls: {
    refDistance: 5, //>0
    maxDistance: 10, //linear only, default 10000
    rollOffFactor: 3, //linear 0-1, inverse 0-inf, exponential 0-inf
    distanceModel: "exponential" //linear, inverse, exponential
  },

  happySoundControls: {
    refDistance: 5, //>0
    maxDistance: 10, //linear only, default 10000
    rollOffFactor: 3, //linear 0-1, inverse 0-inf, exponential 0-inf
    distanceModel: "exponential" //linear, inverse, exponential
  },

  // Terrain
  terrainSize: 150,
  playAreaSize: 147,
  terrainColors: [0x7623f4, 0x22fbff, 0xe22222], // [neutral, good, bad]
  // Tune Nugget properties
  triggerDistance: 3, // nuggets collision detect distance
  numberOfTuneNuggets: 25,
  numberOfHappyTuneNuggets: 8,
  minNuggetDistance: 15,
  tuneNuggetScale: 1,
  tuneNuggetScaleDelta: 1,
  showNuggetDebugObjects: false, // shows debug boxes
  // Rotation in degrees
  tuneNuggetRotationDelta: 360,
  tuneNuggetTimeDelta: 0.2,

  // Computation Throttles
  enemyDistanceUpdateInterval: 30, // # frames
  nuggetDistanceUpdateInterval: 40, // # frames

  // Gameplay
  powerUpDuration: 15, // seconds
  vulnerableDuration: 15, // seconds
  enemyKillAddTime: 10, // seconds added to countdown
  happyNuggetAddHealth: 15,

  // Enemies ( states = [calm, scared, aggro] )
  numberOfEnemies: 20,
  enemyDamageDistance: 3, // distance can damage player
  enemyAutoAttackDistance: 5, // will aggro in neutral mode
  enemyKillDistance: 5, // distance player can kill enemy
  enemyAttackRate: 3000, // milliseconds
  enemyAttackDamage: -10,
  enemyMoveSpeed: [8, 3, 6],
  turnAngle: [0.5, 0.5, 0.5], // radians per turn
  turnInterval: [1, 1, 1], // time between turns
  turnDelta: 30, // %
  agitation: [10, 4, 5], // target change frequency [calm, scared, aggro] in seconds
  agitationDelta: 40, // % variation
  enemyColors: [0xfafafa, 0x00fafa, 0xff8800] // [calm, scared, aggro]
};

export function GetSettings() {
  return Settings;
}

exports.Unify = function(unify) {
  unify.addNewAsset(Settings, "settings");
};
